import React from 'react';

const ML_Testing = () => {
    return (
        <div>ML_Testing Component</div>
    );
}

export default ML_Testing;
